'use strict';

function MetadataHolder () {
  this.rules = [];
}

module.exports = MetadataHolder;

MetadataHolder.prototype.add = function (rule) {
  this.rules.push(rule);
};



//////////////////
// WEBPACK FOOTER
// ./~/turbo-carto/src/model/metadata-holder.js
// module id = 2085
// module chunks = 6